// src/pages/History/20thCentury/RussianRevolutionGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/20th_Century_-_Russian_Revolution_&_USSR.png';

function HistoryPageRussianRevolutionGo() {
  return (
    <QuizPage
      title="History: Russian Revolution & USSR"
      subTopic="Russian Revolution & USSR"
      backgroundImage={historyImage}
      returnPath="/History-Russian-Revolution"
    />
  );
}

export default HistoryPageRussianRevolutionGo;
